import React from "react";
import { node, string } from "prop-types";
import { classes } from "../utils/classes";

const YouTubeVideo = ({ className = "", children }) => {
	return <div className={classes("video-responsive", className)}>{children}</div>;
};

YouTubeVideo.propTypes = {
	className: string,
	children: node.isRequired,
};

export default YouTubeVideo;
